// extracted by mini-css-extract-plugin
export var card = "_4d-0";
export var content = "_4d-1";
export var contentLoading = "_4d-2";